import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class RegisterService {

    constructor(private dataService: DataService) { }

    getStateLookup(refresh: Boolean) {
        return this.dataService.getData('/api/getstates', refresh);
    }

    getDistrictLookup(refresh: Boolean) {
        return this.dataService.getData('/api/getTndistricts', refresh);
    }

    getDivisionDistrictLookup(refresh: Boolean) {
        return this.dataService.getData('/api/getTamindistricts', refresh);
    }

    getWeighbridgeById(payload: any) {
        return this.dataService.post('/api/editMineWeighbridgeList', payload);
    }
    
    getProviders(refresh: Boolean){
        return this.dataService.getData('/api/getProviders', refresh);
    }
    getDevicesList(refresh: Boolean){
        return this.dataService.getData('/api/getDevicesList', refresh);
    }
    getRoles(refresh: Boolean) {
        return this.dataService.getData('/api/getRoles', refresh);
    }

    getDepartments(refresh: Boolean) {
        return this.dataService.getData('/api/getDepartments', refresh);
    }

    getTalukLookup(result: any) {
        return this.dataService.post('/api/taluk/list', result).map(response => {
            return response;
        });
    }

    getOperatorLookup(result: any) {
        return this.dataService.post('/api/weighbridgeList', result).map(response => {
            return response;
        });
    }

    checkWeighbridgeExist(result: any) {
        return this.dataService.post('/api/checkWeighbridgeExist', result).map(response => {
            return response;
        });
    }

    weighbridgeDets(result: any) {
        return this.dataService.post('/api/weighbridgeDets', result).map(response => {
            return response;
        });
    }

    getVehicleByDistrictLookup(result: any) {
        return this.dataService.post('/api/vehicleByDistrict', result).map(response => {
            return response;
        });
    }

    getUserDetails(payload: any) {
        return this.dataService.post('/api/getUserDets', payload).map(response => {
            return response;
        });
    }
    getDivisionLookup(result: any) {
        return this.dataService.post('/api/division/list', result).map(response => {
            return response;
        });
    }
    getFirkaLookup(result: any) {
        return this.dataService.post('/api/firka/list', result).map(response => {
            return response;
        });
    }

    getVillageLookup(result: any) {
        return this.dataService.post('/api/village/list', result).map(response => {
            return response;
        });
    }

    registerSave(result: any) {
        return this.dataService.post('/api/register', result).map(response => {
            return response;
        });
    }

    getPaymentDets(result: any) {
        return this.dataService.post('/api/getPaymentDets', result).map(response => {
            return response;
        });
    }


    feesCheck(result: any) {
        return this.dataService.post('/paygov/payment/check', result).map(response => {
            return response;
        });
    }

    updateUserStatus(result: any) {
        return this.dataService.post('/api/userstatusupdate', result).map(response => {
            return response;
        });
    }

    addUser(payload: any) {
        return this.dataService.post('/api/insertUser', payload).map(response => {
            return response;
        });
    }
    checkUsernameExist(username: any, payload: any){
        return this.dataService.post('/api/checkUsernameExist/'+username, payload).map(response => {
            return response;
        });
    }
    checkUserDataExist(urlData: any){
        let data = {};
        return this.dataService.post('/api/checkUserDataExist/'+urlData, data).map(response => {
            return response;
        }); 
    }

    updateUser(payload: any) {
        return this.dataService.post('/api/updateUser', payload).map(response => {
            return response;
        });
    }

    mobileverification(data: any) {
        return this.dataService.post('/api/sendotp', data).map(response => {
            return response;
        });
    }

    adGenerateotp(data: any) {
        return this.dataService.post('/api/ad/sendotp', data).map(response => {
            return response;
        });
    }

    sendWithdrawOtp(data: any) {
        return this.dataService.post('/api/sendWithdrawOtp', data).map(response => {
            return response;
        });  
    }

    userMobileResetOtp(data: any){
        return this.dataService.post('/api/reset/sendotp',data).map(response =>{
            return response;
        })
    }

    userMobileResetverifyOtp(data:any){
        return this.dataService.post('/api/reset/verifyotp',data).map(response =>{
            return response;
        })
    }

    configurationOtp(data:any){
        return this.dataService.post('/api/admin/sendotp',data).map(response =>{
            return response;
        })
    }

    configurationVerifyOtp(data:any){
        return this.dataService.post('/api/admin/verifyotp',data).map(response =>{
            return response;
        })
    }

    adverfiyotp(data: any) {
        return this.dataService.post('/api/ad/verifyotp', data).map(response => {
            return response;
        });
    }

    verifyWithdrawOtp(data: any) {
        return this.dataService.post('/api/verifyWithdrawOtp', data).map(response => {
            return response;
        });
    }

    otpverification(data: any) {
        return this.dataService.post('/api/verifyotp', data).map(response => {
            return response;
        });
    }


    forgetPasswordGenerateOtp(data: any) {
        return this.dataService.post('/api/forgot/sendotp', data).map(response => {
            return response;
        })
    }

    forgetPasswordVerifyOtp(data: any) {
        return this.dataService.post('/api/forgot/verifyotp', data).map(response => {
            return response;
        })
    }
    
    panprivateVerification(data: any) {
        return this.dataService.post('/api/verifypan', data).map(response => {
            return response;
        });
    }
   
    checkuser(data:any, refresh: Boolean) {
        return this.dataService.getData('/api/checkapplicant/'+ data, refresh);
    }

    checkEmailExist(data: any) {
        return this.dataService.post('/api/checkEmailExist', data).map(response => {
            return response;
        });
    }

    getApplicantDetails(refresh : boolean)
    {
        return this.dataService.getData('/api/applicantDetails/', refresh);
    }

    getMineWiseGpsFitmentReport(params?: any, refresh?: boolean) {
        if (typeof params === 'boolean') {
            return this.dataService.getData('/api/mineWiseGpsFitmentReport', params);
        }
        if (params && typeof params === 'object') {
            return this.dataService.getRecordWithParams('/api/mineWiseGpsFitmentReport', params);
        }
        return this.dataService.getData('/api/mineWiseGpsFitmentReport', refresh !== undefined ? refresh : true);
    }

    getVehicleOwnerDetails(payload: any) {
        return this.dataService.post('/api/getVehicleOwnerDetails', payload).map(response => {
            return response;
        });
    }
}
